export default __webpack_public_path__ + "static/media/6.32545791.jpg";